"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDescription = void 0;
const react_1 = __importDefault(require("react"));
const uuid_1 = require("uuid");
const FieldContext_1 = require("../Field/FieldContext");
const FieldDescription_styles_1 = require("./FieldDescription.styles");
function useFieldDescribeId() {
    const fieldContext = react_1.default.useContext(FieldContext_1.FieldContext);
    const { id, addDescribedById, removeDescribedById } = fieldContext !== null && fieldContext !== void 0 ? fieldContext : {};
    // create a unique id for the description based on the field id
    const describeId = react_1.default.useMemo(() => {
        const uniqueId = (0, uuid_1.v4)();
        return `message-${uniqueId}`;
    }, [id]);
    react_1.default.useEffect(() => {
        addDescribedById === null || addDescribedById === void 0 ? void 0 : addDescribedById(describeId);
        return () => {
            removeDescribedById === null || removeDescribedById === void 0 ? void 0 : removeDescribedById(describeId);
        };
    }, [describeId, addDescribedById, removeDescribedById]);
    return describeId;
}
/**
 * A message that is displayed below the field label and above the field control
 */
const FieldDescription = react_1.default.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const describeId = props.id || useFieldDescribeId();
    return (react_1.default.createElement(FieldDescription_styles_1.StyledFieldDescription, Object.assign({ "data-ds-form-description": "" }, props, { ref: forwardedRef, id: describeId }), children));
});
exports.FieldDescription = FieldDescription;
FieldDescription.displayName = "Form.Description";
//# sourceMappingURL=FieldDescription.js.map